/**
 * @param {*} value
 * @return {value is Map}
 */
export function isMap(value) {
  return value instanceof Map;
}
